import { HomepageFeatureCard, HomepagePlatformSection, PietraAgenticCard, SectionTabType } from '../types/homepage';

import { STATIC_FILE_URL } from '@/shared/constants';
import aiOperations from '@/components/Home/HomepageV4/images/ai-operations.png';
import aiSourcing from '@/components/Home/HomepageV4/images/ai-sourcing.png';
import elevenElevenMedia from '@/components/Home/HomepageV4/images/eleven-eleven-media.png';
import parivieBeauty from '@/components/Home/HomepageV4/images/parivie-beauty.png';

export const SECTION_TABS: SectionTabType[] = [
  {
    activeBgColor: '#FF5C3C',
    activeTextColor: '#fff',
    anchor: '#brand-vault',
    key: 'brand-vault',
    text: 'Personalized AI',
  },
  {
    activeBgColor: '#7D33F7',
    activeTextColor: '#fff',
    anchor: '#ai-business-partner',
    key: 'ai-business-partner',
    text: 'AI Business Partner',
  },
  {
    activeBgColor: '#57AD6A',
    activeTextColor: '#fff',
    anchor: '#slack-connectivity',
    key: 'slack-connectivity',
    text: 'Slack Connectivity',
  },
  {
    activeBgColor: '#C5A827',
    activeTextColor: '#fff',
    anchor: '#sourcing-fulfillment',
    key: 'sourcing-fulfillment',
    text: 'Sourcing & Fulfillment',
  },
];

export const HOMEPAGE_TAB_SECTIONS: HomepagePlatformSection[] = [
  {
    anchor: '#brand-vault',
    addShadow: false,
    id: 'brand-vault',
    isTextLeft: true,
    image: `${STATIC_FILE_URL}/23b27372fd5e50cc30a3f65eccf9b1e7.png`,
    preTitle: {
      text: 'Personalized Brand Vault',
      color: '#FF5C3C',
    },
    title: {
      text: 'One place that knows your business inside and out.',
      color: '#000',
    },
    description: {
      text: 'Connect your data sources, monitor social media and competitors, and let AI personalize every insight to your brand. Your personalized brand vault becomes smarter the more you use it.',
      color: 'rgba(0, 0, 0, 0.6)',
    },
    buttons: [
      {
        text: 'Learn more',
        color: '#fff',
        bgColor: '#FF5C3C',
        path: '/platform/pietra-ai',
      },
    ],
    withPietraComparator: {
      titleGradient: 'linear-gradient(95deg, #FF5C3C 45.89%, #F5BE32 118.46%)',
      borderColor: '#FF5C3C',
      backgroundColor: '#F9F2F1',
      withBullets: [
        'Connect all your data sources in one place',
        'Monitor competitors & social media 24/7',
        'AI personalizes insights to your brand',
        'Always up to date, always in context',
      ],
      withoutBullets: [
        'Switching between disconnected tools',
        'Manual reporting and data pulls',
        'Generic insights that miss the mark',
      ],
    },
  },
  {
    anchor: '#ai-business-partner',
    addShadow: false,
    id: 'ai-business-partner',
    isTextLeft: true,
    image: `${STATIC_FILE_URL}/bd58192614fa88d441d32e5df697f449.png`,
    preTitle: {
      text: 'AI Business Partner',
      color: '#7D33F7',
    },
    title: {
      text: 'An AI that runs your agents and learns your business.',
      color: '#000',
    },
    description: {
      text: 'Chat with your AI partner to run agents, provide custom reports, and define exactly what data you care about and how you want to see it. It gets smarter as your business evolves.',
      color: 'rgba(0, 0, 0, 0.6)',
    },
    buttons: [
      {
        text: 'Learn more',
        color: '#fff',
        bgColor: '#7D33F7',
        path: '/platform/pietra-ai',
      },
    ],
    withPietraComparator: {
      titleGradient: 'linear-gradient(95deg, #535AFF 45.89%, #7D33F7 118.46%)',
      borderColor: '#7D33F7',
      backgroundColor: '#F3EEFF',
      withBullets: [
        'Run agents directly from chat',
        'Provide custom reports anytime',
        'Define your data and how you see it',
        'Context carries across every conversation',
      ],
      withoutBullets: [
        'Re-explaining your business every session',
        'Manually triggering reports',
        'One-size-fits-all AI responses',
      ],
    },
    testimonial: {
      author: {
        brand: 'Parivie Beauty',
        name: 'Shawn Patel',
      },
      bgColor: '#FBEAF6',
      image: parivieBeauty,
      isTextLeft: false,
      review: {
        color: '#000000',
        text: "I can't believe how much more efficient our operations and marketing teams have become by using Pietra's AI agents. It feels like every time I need to analyze data, think of new ideas, or get ahead, Pietra's AI is my go-to answer!",
      },
      title: {
        color: '#1F2026',
        text: 'Parivie Beauty saved 80+ hours per week running their business.',
      },
    },
  },
  {
    anchor: '#slack-connectivity',
    addShadow: false,
    id: 'slack-intelligence',
    isTextLeft: true,
    image: `${STATIC_FILE_URL}/37467abed9fb12e6ab1f4defcab0e347.png`,
    preTitle: {
      text: 'Slack Connectivity',
      color: '#57AD6A',
    },
    title: {
      text: 'Your AI sends insights directly to your Slack.',
      color: '#000',
    },
    description: {
      text: 'Connect Slack and get AI-generated insights delivered as direct messages or scheduled digests — performance summaries, flags, and reports that show up where your team already works.',
      color: 'rgba(0, 0, 0, 0.6)',
    },
    buttons: [
      {
        text: 'Learn more',
        color: '#fff',
        bgColor: '#57AD6A',
        path: '/platform/pietra-fai',
      },
    ],
    withPietraComparator: {
      titleGradient: 'linear-gradient(95deg, #4AB409 45.89%, #09B0B0 118.46%)',
      borderColor: '#57AD6A',
      backgroundColor: '#EBF5ED',
      withBullets: [
        'Get DMs with insights and alerts',
        'Schedule daily or weekly digest reports',
        'No dashboard required — works in Slack',
        'Keep your whole team in the loop',
      ],
      withoutBullets: [
        'Logging into dashboards to check numbers',
        'Building manual weekly reports',
        'Insights that nobody reads',
      ],
    },
    testimonial: {
      author: {
        brand: '11Eleven Media',
        name: 'Adam Domain',
      },
      bgColor: '#F6F1F2',
      image: elevenElevenMedia,
      isTextLeft: false,
      review: {
        color: '#000',
        text: "We use Pietra's AI agents to monitor social trends, analyze competitors, create professional content, and stay informed in real time with advertising performance.",
      },
      title: {
        color: '#1F2026',
        text: "Pietra's AI marketing tools gives my small team superpowers!",
      },
    },
  },
  {
    anchor: '#sourcing-fulfillment',
    addShadow: false,
    id: 'sourcing-fulfillment-ai',
    isTextLeft: true,
    image: aiOperations,
    preTitle: {
      text: 'Sourcing & Fulfillment AI',
      color: '#C5A827',
    },
    title: {
      text: 'AI that answers your toughest ops questions.',
      color: '#000',
    },
    description: {
      text: 'Ask your AI anything about sourcing costs, supplier options, inventory levels, and fulfillment performance. Get clear answers and actionable insights without digging through spreadsheets.',
      color: 'rgba(0, 0, 0, 0.6)',
    },
    buttons: [
      {
        text: 'Learn more',
        color: '#000',
        bgColor: '#f9e070',
        path: '/platform/sourcing-and-production/products',
      },
    ],
    withPietraComparator: {
      titleGradient: 'linear-gradient(95deg, #D09808 45.89%, #64F30D 118.46%)',
      borderColor: '#C5A827',
      backgroundColor: '#FFFBE7',
      withBullets: [
        'Ask questions, get instant sourcing insights',
        'Track fulfillment performance in plain language',
        'Inventory and cost analysis on demand',
        'Connected to your live ops data',
      ],
      withoutBullets: [
        'Digging through supplier spreadsheets',
        'Waiting on account managers for answers',
        'Siloed ops and fulfillment data',
      ],
    },
  },
];

export const FEATURE_CARDS: HomepageFeatureCard[] = [
  {
    title: 'Product design tools',
    desc: 'AI-powered creative tools to bring product & packaging ideas to life.',
    img: `${STATIC_FILE_URL}/445c9a2a3b3b794a92e5116b70a0d12f.png`,
    path: '/platform/design-studio',
    vimeoId: 905396529,
  },
  {
    title: 'Sourcing & Production',
    desc: 'Marketplace of vetted factories for products, packaging, and creative services.',
    img: `${STATIC_FILE_URL}/019bc765a9c56085701ccebba26b0542.png`,
    path: '/platform/sourcing-and-production',
    vimeoId: 905327233,
  },
  {
    title: 'Order fulfillment',
    desc: 'Infrastructure to store and ship products around the world from your website.',
    img: `${STATIC_FILE_URL}/9c112bdaf71d27b7b12cd05fd7911656.png`,
    path: '/platform/logistics-and-fulfillment',
    vimeoId: 905373249,
  },
  {
    title: 'E-commerce storefront',
    desc: 'Create a beautiful website in minutes to start selling fast.',
    img: `${STATIC_FILE_URL}/8ac96eb9e7b5d8e7df82b1892f724465.png`,
    path: '/platform/sales-and-marketing',
    vimeoId: 905460243,
  },
  {
    title: 'Affiliate Marketing',
    desc: 'Set up and run an influencer marketing program.',
    img: `${STATIC_FILE_URL}/2cb0df5c50e9168bb3b35f21d399ac6f.png`,
    path: '/platform/affiliate-marketing',
    vimeoId: 906475808,
  },
  {
    title: 'Data & Dashboards',
    desc: '35+ business dashboards to understand your business.',
    img: `${STATIC_FILE_URL}/cc0628988f0c9b2a2d031affc45c62b0.png`,
    path: '/platform/analytics',
    vimeoId: 905759953,
  },
  {
    title: 'Print on demand',
    desc: 'Make merch and promotional products at heavily discounted rates.',
    img: `${STATIC_FILE_URL}/daaf49beeb9a4e1bc4107243ffe9cbfa.png`,
    path: '/platform/print-on-demand',
    vimeoId: 905737521,
  },
  {
    title: 'Business planning tools',
    desc: 'Get a step-by-step guide to building an online business. Great for beginners getting started.',
    img: `${STATIC_FILE_URL}/23ff97a90a53847d0668beb022d12ae9.png`,
    path: 'https://builder.pietrastudio.com',
    external: true,
    vimeoId: 906172756,
  },
  {
    title: 'Weekly workshops',
    desc: 'Get access to professionals each week to help you maximize Pietra.',
    img: `${STATIC_FILE_URL}/60fd924583a71e41216b6fa0d4e14529.png`,
    path: '/sell-on-pietra/register',
  },
];

export const HOMEPAGE_V4_INTRO_LOGOS = [
  {
    src: '/svg/rhode.png',
    alt: 'Rhode',
    width: 63,
    height: 16,
  },
  {
    src: '/svg/honest.png',
    alt: 'The Honest Company',
    width: 107,
    height: 16,
  },
  {
    src: '/svg/brooklinen.svg',
    alt: 'Brooklinen',
    width: 94,
    height: 16,
  },
  {
    src: '/svg/halfdays.svg',
    alt: 'Halfdays',
    width: 69,
    height: 16,
  },
  {
    src: '/svg/coterie.png',
    alt: 'Coterie',
    width: 75,
    height: 16,
  },
  {
    src: '/svg/atoms.svg',
    alt: 'Atoms',
    width: 89,
    height: 16,
  },
  {
    src: '/svg/canopy.svg',
    alt: 'Canopy',
    width: 55,
    height: 16,
  },
  {
    src: '/svg/lalo.png',
    alt: 'Lalo',
    width: 59,
    height: 16,
  },
  {
    src: '/svg/everlane_logo.svg',
    alt: 'Everlane',
    width: 109,
    height: 16,
  },
  {
    src: '/svg/gorgie.png',
    alt: 'Gorgie',
    width: 81,
    height: 16,
  },
  {
    src: '/svg/jack_archer.png',
    alt: 'Jack Archer',
    width: 152,
    height: 16,
  },
];

export const HOMEPAGE_PIETRA_OFFERINGS = [
  {
    title: 'Source with no fees',
    description: 'Find & work with factories.',
    icon: '/svg/shipment-international.svg',
  },
  {
    title: 'Order fulfillment',
    description: 'Lower costs by up to 40%.',
    icon: '/svg/order-fulfillment.svg',
  },
  {
    title: 'Track industry data',
    description: 'Monitor ads & content.',
    icon: '/svg/ai-search.svg',
  },
  {
    title: 'Hire influencers',
    description: 'Find content-specific creators.',
    icon: '/svg/advertising-megaphone.svg',
  },
  {
    title: 'Make content',
    description: 'Use AI to make marketing assets.',
    icon: '/svg/image-file-ai.svg',
  },
  {
    title: 'Finance a PO',
    description: 'Get special lending rates.',
    icon: '/svg/discount-dollar-dash.svg',
  },
  {
    title: 'Expand into retail',
    description: 'Contact retail buyers worldwide.',
    icon: '/svg/shop.svg',
  },
  {
    title: 'Build an email list',
    description: 'Get emails from website traffic.',
    icon: '/svg/shopping-voucher-mail.svg',
  },
  {
    title: 'Find new customers',
    description: 'Let AI find you new customers.',
    icon: '/svg/human-resources-rating-man.svg',
  },
];

export const AGENTIC_CARDS: PietraAgenticCard[] = [
  {
    icon: {
      url: 'https://static.pietrastudio.com/public/file_uploads/a4377904ddc97ebde8327a3878f0e6a9.svg',
      bgColor: 'radial-gradient(127.58% 127.5% at 25.04% 20.84%, #ECEBFF 0%, #EBE1FE 100%)',
    },
    agentName: 'Social & Market Research Agent',
    title: "Stay on top of your brand's daily news",
    description:
      "I'll track your brand's mentions, competitors, and market trends and deliver daily updates so you can act fast and stay ahead.",
    textColor: 'radial-gradient(127.58% 127.5% at 25.04% 20.84%, #535AFF 0%, #7D33F7 100%)',
  },
  {
    icon: {
      url: 'https://static.pietrastudio.com/public/file_uploads/51904d13540071f9b5072823d19f813b.svg',
      bgColor: 'linear-gradient(43deg, #F9DBDB 26.92%, #FDF1DF 77.91%)',
    },
    agentName: 'Influencer & Affiliate Agent',
    title: 'Spot influencer mentions the moment they happen',
    description:
      "I'll monitor social platforms and alert you when a creator posts about your brand so you never miss a chance to engage.",
    image: `${STATIC_FILE_URL}/d6f483458716d6058c88151dbd693619.png`,
    textColor: 'linear-gradient(43deg, #FF4A4A 26.92%, #E9AA4B 77.91%)',
  },
  {
    icon: {
      url: 'https://static.pietrastudio.com/public/file_uploads/578be5523186e2139a0941fe3ba6a3d3.svg',
      bgColor: 'radial-gradient(208.48% 182.32% at -0.04% -0.23%, #D9EFFF 0%, #DAE4FF 100%)',
    },
    agentName: 'Content Creation Agent',
    title: 'Grow your audience with on-brand social posts',
    description:
      "I'll create posts featuring your products and trending styles to keep your brand relevant, trusted, and top of mind.",
    image: `${STATIC_FILE_URL}/f4ebcb9a39e9500193843df7dfcd4995.png`,
    textColor: 'radial-gradient(208.48% 182.32% at -0.04% -0.23%, #41AFFF 0%, #4865FF 100%)',
  },
  {
    icon: {
      url: 'https://static.pietrastudio.com/public/file_uploads/eb4811114d5268e1ce5e5d0213e8e4bc.svg',
      bgColor: 'radial-gradient(213.37% 213.37% at 27.54% 0%, #E1F5DE 0%, #DBF5E3 100%)',
    },
    agentName: 'Sales & Storefront Agent',
    title: 'Turn website visitors into marketing opportunities',
    description:
      "I'll identify who's visiting your site and turn that data into ready-to-use audiences for ads, emails, and retargeting.",
    textColor: 'radial-gradient(213.37% 213.37% at 27.54% 0%, #71CE51 0%, #32CB8B 100%)',
  },
  {
    icon: {
      url: 'https://static.pietrastudio.com/public/file_uploads/10af9c6bb5d47c9b31f33f46ba5cc727.svg',
      bgColor: 'radial-gradient(127.58% 127.5% at 25.04% 20.84%, #F4DCF9 0%, #FCD7FC 100%)',
    },
    agentName: 'Task Automation Agent',
    title: 'Automate your daily tasks and reports',
    description:
      "From data analysis to performance summaries, I'll handle your routine work so you can focus on what matters most.",
    textColor: 'radial-gradient(127.58% 127.5% at 25.04% 20.84%, #C853FF 0%, #F733EF 100%)',
  },
];
